var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgAvax(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 100,
    height: 100,
    viewBox: "0 0 100 100",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M80.858 17.1123H19.0737V73.3041H80.858V17.1123Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M100 50C100 77.6145 77.6145 100 50 100C22.3858 100 0 77.6145 0 50C0 22.3858 22.3858 0 50 0C77.6145 0 100 22.3858 100 50ZM35.8314 69.8975H26.1278C24.0888 69.8975 23.0816 69.8975 22.4675 69.5047C21.8042 69.0746 21.3989 68.3622 21.3497 67.5759C21.3128 66.8515 21.8165 65.9668 22.8237 64.1981L46.7831 21.9664C47.8026 20.173 48.3184 19.2764 48.9694 18.9447C49.6696 18.5885 50.5049 18.5885 51.205 18.9447C51.856 19.2764 52.3719 20.173 53.3913 21.9664L58.3169 30.5645L58.342 30.6084C59.4431 32.5323 60.0015 33.5079 60.2453 34.5319C60.5155 35.6497 60.5155 36.8288 60.2453 37.9466C59.9997 38.9784 59.4469 39.9611 58.3292 41.914L45.7439 64.1613L45.7113 64.2182C44.6029 66.158 44.0412 67.1411 43.2627 67.8828C42.4152 68.6937 41.3957 69.283 40.2779 69.6152C39.2584 69.8975 38.1161 69.8975 35.8314 69.8975ZM60.3362 69.8975H74.2403C76.2916 69.8975 77.3236 69.8975 77.9381 69.4927C78.6012 69.0626 79.0186 68.3376 79.0559 67.5519C79.0912 66.8509 78.5985 66.0007 77.6332 64.3347C77.5999 64.278 77.5666 64.2202 77.5326 64.1615L70.5679 52.247L70.4887 52.1128C69.51 50.4579 69.016 49.6221 68.3815 49.2991C67.6818 48.9428 66.8582 48.9428 66.1584 49.2991C65.5196 49.6307 65.0038 50.5028 63.9843 52.2593L57.0443 64.1738L57.0206 64.2148C56.0047 65.9685 55.4969 66.8449 55.5336 67.5639C55.5827 68.3502 55.988 69.0746 56.6513 69.5047C57.2532 69.8975 58.285 69.8975 60.3362 69.8975Z",
    fill: "#E84142"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAvax);
export default __webpack_public_path__ + "static/media/avax.997f63b6ac1b30f55192bcbb6cad9b15.svg";
export { ForwardRef as ReactComponent };